import { RefObject, useCallback, useEffect, useState } from 'react';
import { AnchorNavigation } from 'types/studio/studio';

type Params<NavRef extends HTMLElement = HTMLElement> = {
  variant: AnchorNavigation['variant'];
  cardsNavbarRef: RefObject<NavRef | null>;
  linksNavbarRef: RefObject<NavRef | null>;
  navTopPadding: number;
};

export const useScrollCardsNavigation = ({
  variant,
  cardsNavbarRef,
  linksNavbarRef,
  navTopPadding
}: Params) => {
  const [cardsNavSticky, setCardsNavSticky] = useState(variant === 'links');

  const handleScroll = useCallback(() => {
    const cardsNav = cardsNavbarRef?.current;
    const linksNav = linksNavbarRef?.current;

    if (!cardsNav || !linksNav) return;

    const { bottom: cardsNavBottom } = cardsNav.getBoundingClientRect();
    const { offsetHeight: linksNavHeight } = linksNav;

    if (cardsNavBottom - linksNavHeight < navTopPadding) {
      setCardsNavSticky(true);
    } else if (cardsNavBottom - linksNavHeight > navTopPadding) {
      setCardsNavSticky(false);
    }
  }, [cardsNavbarRef, navTopPadding, linksNavbarRef]);

  useEffect(() => {
    if (variant === 'cards') {
      window.addEventListener('scroll', handleScroll, { passive: true });

      return () => window.removeEventListener('scroll', handleScroll);
    }

    return undefined;
  }, [handleScroll, variant]);

  return { cardsNavSticky };
};
